import { generatePath } from 'react-router';

import { SOLUTIONS_PAGE } from '@/common/constants/pages';
import URLProvider from '@/common/services/URLProvider';
import { DriveItemType } from '@/drive/entities/DriveItem/DriveItem.types';
import { DriveItemRequest } from '@/drive/types/DriveItemRequest';
import { PinnedItem, PinnedItemModel, PinnedItemType } from '@/forwarding/entities/PinnedItem/PinnedItem';

export class PinnedCarbonProject implements PinnedItem {
  readonly id: string;
  readonly type = PinnedItemType.CarbonProject;
  readonly projectId: string;

  constructor(project: { id: string }) {
    this.id = `${PinnedItemType.CarbonProject}-${project.id}`;
    this.projectId = project.id;
  }

  getUrl(): string {
    return URLProvider.convertRelativeToAbsolute(generatePath(SOLUTIONS_PAGE, { projectId: this.projectId }));
  }

  toDriveItemRequest(): DriveItemRequest {
    return { type: DriveItemType.CarbonProject, projectId: this.projectId };
  }

  toModel(): PinnedItemModel {
    return { type: this.type, projectId: this.projectId };
  }
}
